export default __webpack_public_path__ + "static/media/HotSale-Enova.d46abd63.png";